import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faHome,
    faMortarPestle,
    faPhone,
    faBook,
    faInfo,
    faBuilding,
    faBars,
    faPlus,
    faPlusSquare, faPhoneAlt
} from '@fortawesome/free-solid-svg-icons'
import {NavLink} from "react-router-dom";
import API from "../../services/API";
import LogoPic from "../../assets/images/logo.png";
import LogoGohar from "../../assets/images/goharzaminLogo.png";
class NavBar extends Component {
    state = {
        user_group : 0,
        is_marketer : 0
    }

    render() {

        return (

            <nav className="rtl main-nav ">

                <div className="text-center my-2 navbar-logo">

                    {
                        window.localStorage.getItem("sysTitle").indexOf('زمین') < 0 ?
                            <img src={LogoPic} alt={window.localStorage.getItem("sysTitle")} className="rounded-3 mx-auto d-block mt-5  " /> :
                            <img src={LogoGohar} alt={window.localStorage.getItem("sysTitle")} className="rounded-3 mx-auto d-block mt-5  " width='200' />
                    }
                </div>
                <NavLink className=" nav-link " to="/home">
                    <FontAwesomeIcon icon={faHome}/>
                    <span className="px-3">خانه</span>
                </NavLink>
                <NavLink className=" nav-link " to="/request/new">
                    <FontAwesomeIcon icon={faPlus}/>
                    <span className="px-3">ثبت درخواست جدید</span>
                </NavLink>
                <NavLink className=" nav-link " to="/requests/1">
                    <FontAwesomeIcon icon={faBars}/>
                    <span className="px-3">مدیریت درخواست ها</span>
                </NavLink>

                <NavLink className=" nav-link " to="/request/new-sc">
                    <FontAwesomeIcon icon={faPlusSquare}/>
                    <span className="px-3">ثبت درخواست بار خرد</span>
                </NavLink>
                <NavLink className=" nav-link " to="/profile/addresses">
                    <FontAwesomeIcon icon={faBuilding}/>
                    <span className="px-3">مدیریت آدرس ها</span>
                </NavLink>
                <NavLink className=" nav-link " to="/contents/about-us">
                    <FontAwesomeIcon icon={faInfo}/>
                    <span className="px-3">درباره ما</span>
                </NavLink>
                <NavLink className=" nav-link " to="/contents/contact-us">
                    <FontAwesomeIcon icon={faPhone}/>
                    <span className="px-3">تماس با ما</span>
                </NavLink>
                <NavLink className=" nav-link " to="/contents/guide">
                    <FontAwesomeIcon icon={faMortarPestle}/>
                    <span className="px-3">راهنما</span>
                </NavLink>
                <NavLink className=" nav-link " to="/contents/rules">
                    <FontAwesomeIcon icon={faBook}/>
                    <span className="px-3">قوانین و مقررات</span>
                </NavLink>
                {/*{
                    this.state.is_marketer === 1 &&

                    <NavLink className=" nav-link " to="/wallet">
                        <FontAwesomeIcon icon={faWallet}/>
                        <span className="px-3">کیف پول</span>
                    </NavLink>
                }*/}
                {
                    this.state.user_group === 7 &&
                    <NavLink className=" nav-link " to="/profile/company">
                        <FontAwesomeIcon icon={faBuilding}/>
                        <span className="px-3">مدیریت اطلاعات شرکت</span>
                    </NavLink>
                }

                <a href='tel:09150100691' className="nav-link" >


                        <FontAwesomeIcon icon={faPhoneAlt} className="text-success"/>

                    <span className="px-3 ">
                        تماس با پشتیبانی
                        (09150100691)
                    </span>

                </a>
            </nav>

        );
    }
    componentDidMount = () => {
        API.index()
            .then((response) => {
                const user_group = response.results.user_groups[0].id; //8 for staff & 7 for manager
                const is_marketer = response.results.user.is_marketer;
                this.setState({user_group , is_marketer});
            })
    }
}

export default NavBar;